import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n    padding: 112px 0;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n	width: 100%;\n	padding: 64px 0;\n	",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import styled from "styled-components";
import { mixins } from "@sy/component-library";
var media = mixins.media;
export var TestimonialWrapper = styled.div.withConfig({
    componentId: "sc-861766d2-0"
})(_templateObject1(), media.large(_templateObject()));
